import React from 'react';
import PropTypes from 'prop-types';
import { DropdownMenu } from '@spark';
import FieldLabel from '@/features/datasets/components/DataCollection/GenerateDataWithAI/shared/FieldLabel';

/**
 * Multi-select with removable chips for Active Labels / Entity types on the
 * Define Task step (shared by the Retrieval Agent and Generate-with-AI).
 */
const LabelsMultiSelect = ({ heading, options, selected, onChange }) => (
    <div className="gdai-field">
        <FieldLabel text={heading} />
        <DropdownMenu
            selectType="multi-select"
            size="medium"
            fill
            showLabel={false}
            placeholder="Select"
            tags={selected}
            onTagRemove={(tag) => onChange(selected.filter((name) => name !== tag))}
            value={selected}
            items={options.map((name) => ({
                label: name,
                type: 'checkbox',
                checked: selected.includes(name),
            }))}
            onSelect={(item) =>
                onChange(
                    selected.includes(item.label)
                        ? selected.filter((name) => name !== item.label)
                        : [...selected, item.label]
                )
            }
        />
    </div>
);

LabelsMultiSelect.propTypes = {
    heading: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
    selected: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default LabelsMultiSelect;
